import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CssVarsProvider } from "@mui/joy/styles";
import { HelmetProvider } from "react-helmet-async";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SignIn from "./components/SignIn";
import Profile from "./components/Profile";
import WorkerPanel from "./components/WorkerPanel";
import Contact from "./components/Contact";
import Team from "./components/Team";
import Web3Services from "./components/Web3services";
import Register from "./components/Register";
import Portfolio from "./components/Portfolio";
import Home from "./components/Home";
import AdminPanel from "./components/AdminPanel";
import Mint from "./components/Mint";
import Idcard from "./components/IdCard";
import AboutUs from "./components/AboutUs";
import MosaicAgency from "./pages/MosaicAgency";
import Background from "./components/Background";
import CryptoTicker from "./components/CryptoTicker"; // ✅ Import ticker

export default function App() {
  return (
    <HelmetProvider>
      <CssVarsProvider>
        <Background />
        <BrowserRouter>
          <Navbar />
          <CryptoTicker /> {/* ✅ Shows under Navbar on every page */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/welcome"
              element={
                <div style={{ marginTop: "100px", textAlign: "center" }}>
                  Welcome! You’re signed in.
                </div>
              }
            />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/worker" element={<WorkerPanel />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/agency" element={<MosaicAgency />} />
            <Route path="/team" element={<Team />} />
            <Route path="/idcard" element={<Idcard />} />
            <Route path="/mint" element={<Mint />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/Web3" element={<Web3Services />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </CssVarsProvider>
    </HelmetProvider>
  );
}
